import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { Typography } from '../typography';

const Styled = styled.span`
    background: rgba(32, 35, 55, 0.8);
    padding: 10px 18px;
    display: block;
    height: 100%;
    width: 100%;
    color: ${p => p.theme.palette.neutral.silver};

    ${p => p.theme.breakpoints.down('md')} {
        padding: 8px 16px;
    }
    ${p => p.theme.breakpoints.down('sm')} {
        padding: 6px 12px 8px;
    }
`;

interface ImageCompareTextCardLabelProps {
    label: string;
    type: 'left' | 'right';
}

export const ImageCompareTextCardLabel = ({label, type}: ImageCompareTextCardLabelProps):JSX.Element | null => {
    if (!label || !type) return null;

    /**
     * TODO: Investigate alternative solutions
     * This is gross. Don't yell at me.  react-image-compare doesn't have a way to style the label container div.
     * Obviously this goes against typical react rendering, but it resets the styles set by the library so we can
     *   position the label at the bottom of the images rather than the center.
     */
    const labelRef = useRef<HTMLSpanElement>(null);
    useEffect(() => {
        if (labelRef && labelRef.current && labelRef.current.parentNode) {
            const parent = labelRef.current.parentNode as HTMLDivElement;
            parent.style.top = 'initial';
            parent.style.bottom = '-20px';
            parent.style.right = 'initial';
            parent.style.left = 'initial';
            parent.style.background = 'initial';
            parent.style.padding = 'initial';

            if (type === 'left') {
                parent.style.left = '0px';
            } else if (type === 'right') {
                parent.style.right = '0px';
            }
        }
    }, [labelRef, type]);

    return (
        <Styled ref={labelRef} className={classNames('compare-label', type)} key={`compare-label-${label}`}>
            <Typography variant="h4">{label}</Typography>
        </Styled>
    );
}
